// 订单金额格式化公共方法
// 根据金额处理方式对订单合计金额进行格式化处理
// amt 金额数值
// type 金额处理方式: '0'-按系统精度保留小数, '1'-保留1位小数(向下取整), '2'-取整(向下取整), '3'-保留1位小数(四舍五入)
// precision 系统金额精度(小数位数, 仅 type 为 '0' 时使用)
function formatOrderAmt(amt, type, precision) {
    if (type == '0') {
        amt = amt.toFixed(precision);
    } else if (type == '1') {
        amt = Math.floor(amt * 10) / 10;
    } else if (type == '2') {
        amt = Math.floor(amt * 1) / 1;
    } else if (type == '3') {
        amt = amt.toFixed(1);
    } else {
        amt = amt.toFixed(0);
    }
    return amt;
}

export default formatOrderAmt
